import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
  Divider,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getEmployee } from '../../../network/employee';
import {
  addSalarySlip,
  getSalarySlipById,
  updateSalarySlip,
} from '../../../network/salarySlip';
import PaymentsList from './PaymentsList';
import DeductionsList from './DeductionsList';
import EarningsList from './EarningsList';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import HeadingApp from '../../../hooks/HeadingApp';
const AddSalarySlipHr = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const decodedId = decodeURIComponent(id);
  const { companyName } = useSelector((state) => state.user);
  const [dataSourcePayments, setDataSourcePayments] = useState([{}]);
  const [dataSourceDeductions, setDataSourceDeductions] = useState([{}]);
  const [dataSourceEarnings, setDataSourceEarnings] = useState([{}]);
  // console.log(dataSourcePayments, 'dataSourcePayments');

  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddAdditionalSalay } = useMutation({
    mutationKey: ['addSalarySlip'],
    mutationFn: (body) =>
      edit ? updateSalarySlip(body, decodedId) : addSalarySlip(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getSalarySlip] });
      form.resetFields();
      navigate('/salary-slip-hr');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: additionalSalayDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getSalarySlip, decodedId],
    queryFn: () => getSalarySlipById(decodedId),
    enabled: !!edit,
  });
  const { data: employee } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAdditionalSalay({
      ...values,
      company: companyName,
      payroll_frequency: 'Monthly',
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      start_date: dayjs(values?.start_date).format('YYYY-MM-DD'),
      end_date: dayjs(values?.end_date).format('YYYY-MM-DD'),
    });
  };
  useEffect(() => {
    if (edit && additionalSalayDetails) {
      setDataSourcePayments({
        gross_pay: additionalSalayDetails?.data?.gross_pay,
        gross_year_to_date: additionalSalayDetails?.data?.gross_year_to_date,
        total_deduction: additionalSalayDetails?.data?.total_deduction,
        base_total_deduction:
          additionalSalayDetails?.data?.base_total_deduction,
        net_pay: additionalSalayDetails?.data?.net_pay,
        rounded_total: additionalSalayDetails?.data?.rounded_total,
        base_rounded_total: additionalSalayDetails?.data?.base_rounded_total,
        year_to_date: additionalSalayDetails?.data?.year_to_date,
        total_in_words: additionalSalayDetails?.data?.total_in_words,
        total_earnings: additionalSalayDetails?.data?.total_earnings,
        bank_name: additionalSalayDetails?.data?.bank_name,
      });
      setDataSourceDeductions(additionalSalayDetails?.data?.deductions);
      setDataSourceEarnings(additionalSalayDetails?.data?.earnings);
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        posting_date: dayjs(additionalSalayDetails?.data?.posting_date),
        start_date: dayjs(additionalSalayDetails?.data?.start_date),
        end_date: dayjs(additionalSalayDetails?.data?.end_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, additionalSalayDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditSalarySlip : t.addSalarySlip}
        path="/salary-slip-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.salarySlip}
        subTitle={edit ? t.EditSalarySlip : t.addSalarySlip}
        icon={<FaMoneyCheckAlt />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-additional-salay"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        // onAdvanceDetails({ employee:value });
                        form.setFieldsValue({
                          employee_name: option?.option?.employee_name,
                          department: option?.option?.department,
                          designation: option?.option?.designation,
                        });
                      }}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employee?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>
                {edit && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="branch" label={t.branch}>
                      <Input placeholder={t.branch} disabled={edit} />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="designation" label={t.designation}>
                    <Input placeholder={t.designation} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                    style={{ width: '100%' }}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="start_date"
                    label={t.startDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                    style={{ width: '100%' }}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.startDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="end_date"
                    label={t.dateEnd}
                    rules={[{ required: true }]}
                    initialValue={dayjs().endOf('month')}
                    style={{ width: '100%' }}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.dateEnd}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                {edit && (
                  <>
                    <Divider orientation="left">{t.Earnings}</Divider>
                    <Col span={24}>
                      <EarningsList
                        setDataSource={setDataSourceEarnings}
                        dataSource={dataSourceEarnings}
                        t={t}
                        form={form}
                      />
                    </Col>
                    <Divider orientation="left">{t.deductions}</Divider>
                    <Col span={24}>
                      <DeductionsList
                        setDataSource={setDataSourceDeductions}
                        dataSource={dataSourceDeductions}
                        t={t}
                        form={form}
                      />
                    </Col>
                    <Divider orientation="left">{t.Payments}</Divider>
                    {/* <Col span={24}>
                  <PaymentsList
                    setDataSource={setDataSourcePayments}
                    dataSource={dataSourcePayments}
                    t={t}
                    form={form}
                  />
                </Col> */}
                    <Col>
                      <Form.Item name="gross_pay" label={t.gross_pay}>
                        <Input placeholder={t.gross_pay} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="gross_year_to_date"
                        label={t.gross_year_to_date}
                      >
                        <Input
                          placeholder={t.gross_year_to_date}
                          disabled={edit}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="total_deduction"
                        label={t.total_deduction}
                      >
                        <Input
                          placeholder={t.total_deduction}
                          disabled={edit}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="total_in_words" label={t.total_in_words}>
                        <Input placeholder={t.total_in_words} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="total_earnings" label={t.total_earnings}>
                        <Input placeholder={t.total_earnings} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="net_pay" label={t.net_pay}>
                        <Input placeholder={t.net_pay} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="mode_of_payment" label={t.ModeofPayment}>
                        <Input placeholder={t.ModeofPayment} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="total_working_days"
                        label={t.totalWorkingDays}
                      >
                        <Input
                          placeholder={t.totalWorkingDays}
                          disabled={edit}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="leave_without_pay"
                        label={t.leaveWithoutPay}
                      >
                        <Input
                          placeholder={t.leaveWithoutPay}
                          disabled={edit}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="absent_days" label={t.absentDays}>
                        <Input placeholder={t.absentDays} disabled={edit} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="payment_days" label={t.paymentDays}>
                        <Input placeholder={t.paymentDays} disabled={edit} />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {edit && (
                  <>
                    {/* <Col>
      <Form.Item name="branch" label={t.branch}>
        <Input placeholder={t.branch} disabled={edit} />
      </Form.Item>
    </Col> */}
                    {/* <Col>
                  <Form.Item name="status" label={t.status}>
                    <Input placeholder={t.status} disabled={edit} />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item name="exchange_rate" label={t.exchangeRate}>
                    <Input placeholder={t.exchangeRate} disabled={edit} />
                  </Form.Item>
                </Col> */}
                  </>
                )}
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddSalarySlipHr;
